import { useContext, useState } from "react";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";
import { format, startOfMonth } from "date-fns";

const defaultTake = 10;

export const useAPIGetPermintaanMinyak = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();

  const [filterValue, setFilterValue] = useState({
    tanggal_dari: startOfMonth(new Date()),
    tanggal_sampai: new Date(),
    nomor: "",
    department_id: null,
    data_department: null,
    jenis_minyak_id: null,
    data_jenis_minyak: null,
    status: "",
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });
  const [listData, setListData] = useState([]);

  //  API call section

  const fetchListData = async ({ page, take, filter }) => {
    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/transaksi/permintaanminyak/data`,
      params: {
        page: page,
        take: take,
        filter: newFilter,
        order: "tanggal",
        order_method: "DESC",
        with_department: 1,
        with_jenis_minyak: 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: newFilter,
        });
        const newData = data.map((el, index) => {
          return {
            ...el,
            no: (page - 1) * take + index + 1,
          };
        });
        setListData(newData);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];

    const newFilterValue = _filterValue ?? filterValue;

    if (newFilterValue.tanggal_dari) {
      filterArr.push(
        `tanggal:>=:${format(newFilterValue.tanggal_dari, "yyyy-MM-dd")} 00:00:00`
      );
    }

    if (newFilterValue.tanggal_sampai) {
      filterArr.push(
        `tanggal:<=:${format(newFilterValue.tanggal_sampai, "yyyy-MM-dd")} 23:59:59`
      );
    }

    if (newFilterValue.nomor) {
      filterArr.push(`nomor:contains:${newFilterValue.nomor}`);
    }

    if (newFilterValue.department_id) {
      filterArr.push(`department_id:=:${newFilterValue.department_id}`);
    }

    if (newFilterValue.jenis_minyak_id) {
      filterArr.push(`jenis_minyak_id:=:${newFilterValue.jenis_minyak_id}`);
    }

    if (newFilterValue.status !== "" && newFilterValue.status !== null) {
      filterArr.push(`status:=:${newFilterValue.status}`);
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async () => {
    fetchListData({ page: 1, take: defaultTake });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnUpdateViewRow = (row) => {
    let foundInList = false;
    let newListData = listData.map((el) => {
      if (el.id === row.id) {
        foundInList = true;
        return { ...el, ...row };
      }
      return el;
    });

    if (!foundInList) {
      newListData.unshift(row);
    }

    // reorder no
    newListData = newListData.map((el, index) => {
      return {
        ...el,
        no: (paging.page - 1) * paging.take + index + 1,
      };
    });

    setListData(newListData);
  };

  const handleOnDeleteViewRow = (row) => {
    let newListData = [...listData];

    const index = newListData.findIndex((el) => el.id === row.id);
    if (index > -1) {
      newListData.splice(index, 1);
    }

    // reorder no
    newListData = newListData.map((el, index) => {
      return {
        ...el,
        no: (paging.page - 1) * paging.take + index + 1,
      };
    });

    setListData(newListData);
  };

  return {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  };
};
